var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";

import InputText from "../controls/InputText";
import InputNumber from "../controls/InputNumber";
import InputCheckbox from "../controls/InputCheckbox";

var Control = function (_Component) {
  _inherits(Control, _Component);

  function Control() {
    _classCallCheck(this, Control);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Control.prototype.getComponent = function getComponent() {
    var _props = this.props,
        name = _props.name,
        _onChange = _props.onChange,
        value = _props.value;


    switch (typeof value === "undefined" ? "undefined" : _typeof(value)) {
      case "boolean":
        return React.createElement(InputCheckbox, {
          onChange: function onChange(value, valid) {
            return _onChange(name, Boolean(value), valid);
          },
          value: Boolean(value)
        });
      case "number":
        return React.createElement(InputNumber, {
          onChange: function onChange(value, valid) {
            return _onChange(name, Number(value), valid);
          },
          value: Number(value)
        });
      case "string":
        return React.createElement(InputText, {
          onChange: function onChange(value, valid) {
            return _onChange(name, String(value), valid);
          },
          value: String(value)
        });
    }

    return null;
  };

  Control.prototype.getClassName = function getClassName() {
    var _props2 = this.props,
        classNames = _props2.classNames,
        value = _props2.value;

    var type = typeof value === "undefined" ? "undefined" : _typeof(value);
    return type && classNames[type] ? classNames[type] : null;
  };

  Control.prototype.getStyle = function getStyle() {
    var _props3 = this.props,
        styles = _props3.styles,
        value = _props3.value;

    var type = typeof value === "undefined" ? "undefined" : _typeof(value);
    return type && styles[type] ? styles[type] : null;
  };

  Control.prototype.renderControl = function renderControl() {
    var ControlComponent = this.getComponent();

    if (ControlComponent) {
      return React.cloneElement(ControlComponent, {
        className: this.getClassName(),
        style: this.getStyle()
      });
    }

    return "-";
  };

  Control.prototype.render = function render() {
    var name = this.props.name;

    return React.createElement(
      "div",
      null,
      "  ",
      React.createElement(
        "span",
        { className: "token attr-name" },
        name
      ),
      React.createElement(
        "span",
        { className: "token attr-value" },
        React.createElement(
          "span",
          { className: "token punctuation" },
          "={"
        ),
        React.createElement(
          "span",
          null,
          this.renderControl()
        ),
        React.createElement(
          "span",
          { className: "token punctuation" },
          "}"
        )
      )
    );
  };

  return Control;
}(Component);

Control.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  classNames: PropTypes.shape({
    boolean: PropTypes.string,
    number: PropTypes.string,
    string: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired,
  styles: PropTypes.shape({
    boolean: PropTypes.object,
    number: PropTypes.object,
    string: PropTypes.object
  }),
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.bool, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string]).isRequired
} : {};

Control.defaultProps = {
  classNames: {
    string: "",
    boolean: "",
    number: ""
  },
  styles: {
    string: null,
    boolean: null,
    number: null
  }
};

export default Control;